import IndexedFormRow from './IndexedFormRow';

export default IndexedFormRow;


// WEBPACK FOOTER //
// ./src/components/forms/IndexedFormRow/index.js